export default {
  bot: 'Bot',
  campaign: 'Campaign',
  audit: 'Audience',
  failed: 'Failed',
  received: 'Received',
  read: 'Read',
  scheduled: 'Scheduled',
  send_date: 'Send Date',
  processed: 'Processed',
};
